import React, {Component} from 'react';
const { connect } = require('react-redux');
import {Helmet} from 'react-helmet';

import HeaderBrief from '../../components/profile/HeaderBrief';
import MemberPhotoList from 'components/list/MemberPhotoList';
import Loading from 'components/Loading';
import NotFound from 'containers/NotFound';

import {getProfileAlbum} from 'reducers/profileAlbum';

import {t, dt} from 'l10n'

import 'sass/profile/ProfileIndex.scss';
import 'sass/profile/myalbum.scss';

class ProfileAlbum extends Component {
    static fetchData({dispatch, match}) {
        let {nick} = match.params;

        return dispatch(getProfileAlbum(nick));
    }

    componentDidMount() {
        let {dispatch, match, user} = this.props;

        if (!user || match.params.nick !== user.nick) {
            this.constructor.fetchData({dispatch, match})
        }
    }

    render() {
        let {match, user, online, memberPhotos, openMemberPhoto} = this.props,
            {list, totalCount} = memberPhotos;

        if (!user) {
            return <Loading centered/>;
        }

        if (user._notFound) {
            return <NotFound {...this.props}/>
        }

        return (
            <div id="wrapper">
                <HeaderBrief user={user} online={online} match={match}/>
                {user &&
                    <Helmet>
                        <title>{dt('meta', 'Photos of %1', user.nick, user.region || user.country)}</title>
                        <meta name="description" content={dt('meta', 'profile photos description', user.nick, user.country)}/>
                    </Helmet>
                }
                <aside className="my-album">
                    <div className="content">
                        <div className="heading">
                            <h2>{t('Album')} <em>{totalCount}</em></h2>
                        </div>

                        <MemberPhotoList
                            memberPhotos={list}
                            viewFn={openMemberPhoto}
                            xxlCheck
                        />
                    </div>
                </aside>
            </div>
        )
    }
}

export default connect(
    state => ({
        user: state.profileAlbum.user,
        online: state.profileAlbum.online,
        memberPhotos: state.profileAlbum.memberPhotos,
    })
)(ProfileAlbum)


// WEBPACK FOOTER //
// ./src/containers/profile/ProfileAlbum.js